"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _styledComponents = require("styled-components");

var _const = require("../../../const");

var _collapsingNav = require("./collapsing-nav.styled");

var _const2 = require("./const");

var _default = function _default(theme) {
  return {
    [_const2.CollapsingNavThemeVariants.MOCASSIN]: (0, _styledComponents.css)(["", "{background-color:", ";}", "{background-color:", ";}"], _collapsingNav.CollapsingNavTargetStyled, _const.Colors.secondary, _collapsingNav.CollapsingNavLinksListStyled, _const.Colors.secondary),
    [_const2.CollapsingNavThemeVariants.SEASHELL]: (0, _styledComponents.css)(["", "{background-color:", ";}"], _collapsingNav.CollapsingNavTargetStyled, _const.Colors.secondaryLight),
    [_const2.CollapsingNavThemeVariants.WHITE]: (0, _styledComponents.css)(["", "{background-color:", ";border:1px solid ", ";", " &:not(:last-of-type){border-bottom:none;}}", "{& > ", "{border:none;}}", "{border:1px solid ", ";border-top:none;}", "{background-color:", ";}"], _collapsingNav.CollapsingNavTargetStyled, _const.Colors.white, _const.Colors.gray300, function (_ref) {
      var $isOpened = _ref.theme.$isOpened;
      return $isOpened ? (0, _styledComponents.css)(["border-bottom:none;"]) : "";
    }, _collapsingNav.CollapsingNavLinksBlockStyled, _collapsingNav.CollapsingNavTargetStyled, _collapsingNav.CollapsingNavBodyStyled, _const.Colors.gray300, _collapsingNav.CollapsingNavLinksListStyled, _const.Colors.white),
    [_const2.CollapsingNavThemeVariants.DEFAULT]: (0, _styledComponents.css)([""])
  }[theme];
};

exports.default = _default;